import React from "react";
import { Row, Col } from "react-bootstrap";
const PageContentWrapper = (props) => {
  return (
    <div
      className={`page-content-wrapper ps-2 pe-2 bg-white ${
        props.pageClass ? props.pageClass : ""
      }`}
    >
      <Row>
        <Col>
          <h4 className="border-bottom pb-2 pt-2" style={{ margin: 0 }}>
            {props.contentHeading}
          </h4>
        </Col>
      </Row>
      {props.children}
    </div>
  );
};

export default PageContentWrapper;
